
  import Task, { TaskProgress, TaskStatus } from '../models/Task'
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { date, QBtn, QCard, QCardActions, QCardSection, QCarousel, QCarouselSlide, QChip, QTooltip } from 'quasar'
  import { dateUtils } from '@parantion/components'

  const { distanceInWordsToNow, convertDateFormatToISO_8601 } = dateUtils

  @Component({
    components: {
      QCarouselSlide,
      QTooltip,
      QCarousel,
      QChip,
      QCardActions,
      QCard,
      QCardSection,
      QBtn
    },
    filters: {
      dateFilter(val) {
        return val ? convertDateFormatToISO_8601(val, 'dd MMMM yyyy') : '-'
      },
    }
  })
  export default class TaskCard extends Vue {
    @Prop()
    task: Task

    get isOpen() {
      return this.task.status === TaskStatus.OPEN
    }

    get sideClass() {
      if (this.isClosed) {
        return 'closed'
      }
      switch (this.task.field.progress) {
        case TaskProgress.INVITE:
          return 'open'
        case TaskProgress.REMIND:
          return 'open'
        case TaskProgress.BUSY:
          return 'busy'
        case TaskProgress.DONE:
          return 'done'
      }
    }

    get timeInWords() {
      if (!this.task.field['frm_date_end']) return ''
      const dateValue = new Date(this.task.field['frm_date_end'])
      return distanceInWordsToNow(dateValue, { addSuffix: true })
    }

    get twoDaysToGo() {
      const difference = date.getDateDiff(this.task.field['frm_date_end'], new Date(), 'days')
      // @ts-ignore
      return !isNaN(difference) && (difference === 2 || difference === 1)
    }

    get coupleHoursToGo() {
      const difference = date.getDateDiff(this.task.field['frm_date_end'], new Date(), 'hours')
      // @ts-ignore
      return !isNaN(difference) && difference < 24
    }

    get isClosed() {
      const difference = date.getDateDiff(this.task.field['frm_date_end'], new Date(), 'hours')
      // @ts-ignore
      return !isNaN(difference) && difference < 1
    }

    get textClass() {
      if (this.coupleHoursToGo) return 'text-red-4'
      else if (this.twoDaysToGo) return 'text-orange-4'
      else return 'text-grey-7'
    }
  }
